export default __webpack_public_path__ + "static/media/ApplauseHub.f6bff4a081e5c176e3203222be56964a.webp";